const countryToIso = {
  // Afrique
  'Gabon': 'ga',
  'Cameroun': 'cm',
  'Cameroon': 'cm',
  'Sénégal': 'sn',
  'Senegal': 'sn',
  'Côte d\'Ivoire': 'ci',
  'Ivory Coast': 'ci',
  'Congo': 'cg',
  'République du Congo': 'cg',
  'Republic of the Congo': 'cg',
  'RDC': 'cd',
  'République Démocratique du Congo': 'cd',
  'Democratic Republic of the Congo': 'cd',
  'Congo-Kinshasa': 'cd',
  'Congo-Brazzaville': 'cg',
  'Mali': 'ml',
  'Burkina Faso': 'bf',
  'Niger': 'ne',
  'Tchad': 'td',
  'Chad': 'td',
  'Guinée': 'gn',
  'Guinea': 'gn',
  'Guinée équatoriale': 'gq',
  'Equatorial Guinea': 'gq',
  'Guinée-Bissau': 'gw',
  'Guinea-Bissau': 'gw',
  'Bénin': 'bj',
  'Benin': 'bj',
  'Togo': 'tg',
  'Ghana': 'gh',
  'Nigeria': 'ng',
  'Nigéria': 'ng',
  'Afrique du Sud': 'za',
  'South Africa': 'za',
  'Maroc': 'ma',
  'Morocco': 'ma',
  'Algérie': 'dz',
  'Algeria': 'dz',
  'Tunisie': 'tn',
  'Tunisia': 'tn',
  'Égypte': 'eg',
  'Egypt': 'eg',
  'Libye': 'ly',
  'Libya': 'ly',
  'Mauritanie': 'mr',
  'Mauritania': 'mr',
  'Madagascar': 'mg',
  'Maurice': 'mu',
  'Mauritius': 'mu',
  'Mozambique': 'mz',
  'Angola': 'ao',
  'Éthiopie': 'et',
  'Ethiopia': 'et',
  'Kenya': 'ke',
  'Tanzanie': 'tz',
  'Tanzania': 'tz',
  'Ouganda': 'ug',
  'Uganda': 'ug',
  'Rwanda': 'rw',
  'Burundi': 'bi',
  'Centrafrique': 'cf',
  'République centrafricaine': 'cf',
  'Central African Republic': 'cf',
  'Sierra Leone': 'sl',
  'Liberia': 'lr',
  'Libéria': 'lr',
  'Cap-Vert': 'cv',
  'Cape Verde': 'cv',
  'Cabo Verde': 'cv',
  'São Tomé-et-Príncipe': 'st',
  'Sao Tome and Principe': 'st',
  'Comores': 'km',
  'Comoros': 'km',
  'Djibouti': 'dj',
  'Érythrée': 'er',
  'Eritrea': 'er',
  'Somalie': 'so',
  'Somalia': 'so',
  'Soudan': 'sd',
  'Sudan': 'sd',
  'Soudan du Sud': 'ss',
  'South Sudan': 'ss',
  'Namibie': 'na',
  'Namibia': 'na',
  'Botswana': 'bw',
  'Zimbabwe': 'zw',
  'Zambie': 'zm',
  'Zambia': 'zm',
  'Malawi': 'mw',
  'Lesotho': 'ls',
  'Eswatini': 'sz',
  'Swaziland': 'sz',
  'Gambie': 'gm',
  'Gambia': 'gm',
  'Seychelles': 'sc',

  // Europe
  'France': 'fr',
  'Belgique': 'be',
  'Belgium': 'be',
  'Suisse': 'ch',
  'Switzerland': 'ch',
  'Allemagne': 'de',
  'Germany': 'de',
  'Espagne': 'es',
  'Spain': 'es',
  'Italie': 'it',
  'Italy': 'it',
  'Portugal': 'pt',
  'Royaume-Uni': 'gb',
  'United Kingdom': 'gb',
  'Pays-Bas': 'nl',
  'Netherlands': 'nl',
  'Luxembourg': 'lu',
  'Autriche': 'at',
  'Austria': 'at',
  'Irlande': 'ie',
  'Ireland': 'ie',
  'Suède': 'se',
  'Sweden': 'se',
  'Norvège': 'no',
  'Norway': 'no',
  'Danemark': 'dk',
  'Denmark': 'dk',
  'Finlande': 'fi',
  'Finland': 'fi',
  'Pologne': 'pl',
  'Poland': 'pl',
  'Grèce': 'gr',
  'Greece': 'gr',
  'Roumanie': 'ro',
  'Romania': 'ro',
  'Turquie': 'tr',
  'Turkey': 'tr',
  'Türkiye': 'tr',
  'Russie': 'ru',
  'Russia': 'ru',

  // Amérique
  'Canada': 'ca',
  'États-Unis': 'us',
  'United States': 'us',
  'USA': 'us',
  'Mexique': 'mx',
  'Mexico': 'mx',
  'Brésil': 'br',
  'Brazil': 'br',
  'Argentine': 'ar',
  'Argentina': 'ar',
  'Colombie': 'co',
  'Colombia': 'co',
  'Chili': 'cl',
  'Chile': 'cl',
  'Pérou': 'pe',
  'Peru': 'pe',
  'Venezuela': 've',
  'Haïti': 'ht',
  'Haiti': 'ht',
  'Cuba': 'cu',
  'République dominicaine': 'do',
  'Dominican Republic': 'do',
  'Jamaïque': 'jm',
  'Jamaica': 'jm',
  'Guyane': 'gf',
  'Guadeloupe': 'gp',
  'Martinique': 'mq',
  'La Réunion': 're',
  'Mayotte': 'yt',

  // Asie
  'Chine': 'cn',
  'China': 'cn',
  'Japon': 'jp',
  'Japan': 'jp',
  'Inde': 'in',
  'India': 'in',
  'Corée du Sud': 'kr',
  'South Korea': 'kr',
  'Thaïlande': 'th',
  'Thailand': 'th',
  'Vietnam': 'vn',
  'Viêt Nam': 'vn',
  'Indonésie': 'id',
  'Indonesia': 'id',
  'Malaisie': 'my',
  'Malaysia': 'my',
  'Philippines': 'ph',
  'Singapour': 'sg',
  'Singapore': 'sg',
  'Émirats arabes unis': 'ae',
  'United Arab Emirates': 'ae',
  'Arabie saoudite': 'sa',
  'Saudi Arabia': 'sa',
  'Qatar': 'qa',
  'Liban': 'lb',
  'Lebanon': 'lb',
  'Israël': 'il',
  'Israel': 'il',

  // Océanie
  'Australie': 'au',
  'Australia': 'au',
  'Nouvelle-Zélande': 'nz',
  'New Zealand': 'nz',
};

export function getCountryCode(countryName) {
  if (!countryName) return null;
  return countryToIso[countryName] || countryToIso[countryName.trim()] || null;
}

export function getCountryFlag(countryName) {
  const code = getCountryCode(countryName);
  if (!code) return '';
  return code.toUpperCase().replace(/./g, char =>
    String.fromCodePoint(char.charCodeAt(0) + 127397)
  );
}
